import AdSlot from './AdSlot';
export default AdSlot;